// mrpoint: ポイント適用後のカート更新でもチェックを走らせる
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    document.dispatchEvent(new CustomEvent('mrpoint:cart-updated'));
  });
}
